/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import { mdiLoading } from '@mdi/js';
import Icon from '@mdi/react';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import formatDate from 'date-fns/format';
import { useIntl } from 'react-intl';
import usePostAppointment from '../../hooks/usePostAppointment';
import { SlotsByDate } from "../../hooks/useStoreSlots";
import getStoreSlots from "../../api/getStoreSlots";
import { FreeSlot } from "../../types/FreeSlot";
import useSetWizardStep from '../../hooks/useSetWizardStep';
import useWizardContext from '../../hooks/useWizardContext';
import { WizardStep } from '../../types/Wizard';
import usePromotions from '../../hooks/usePromotions';
import classes from './classes.module.css';

const Summary: React.FC = () => {
  const [isSubmitted, setIsSubmitted] = React.useState<boolean>(false);
  const setStep = useSetWizardStep();
  const ctx = useWizardContext();
  const intl = useIntl();

  const formatSelectedSlot = (locale: string, d: Date) => {
    const time = d.toLocaleTimeString(locale, {
      hour: 'numeric',
      hour12: false,
      minute: '2-digit',
    });

    const day = d.toLocaleDateString(locale, {
      weekday: 'long',
    });

    const date = d.toLocaleDateString(locale, {
      day: 'numeric',
      month: 'long',
    });

    return `${time}, ${day}, ${date}`;
  };

  const handleEdit = React.useCallback(
    (id: number) => {
      setStep(id as WizardStep);
    },
    [setStep],
  );

  const { firstName, lastName } = ctx.personalInformation || {};
  const { name: appointment } = ctx.appointmentType || {};
  const { name, city } = ctx.store || {};
  const { startDateTime } = ctx.storeSlot || {};
  const promotions = usePromotions();

  const [postAppointmentResponse, regAppointment] = usePostAppointment();
  const [slotsByDate, setStoreSlots] = React.useState<SlotsByDate | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [slotAvailability, setSlotAvailability] = useState(true);

  //This API Verification Code takes stuff from the useStoreSlots hook, in ordered to be used in a button press.
  //This is not good practice and should be rewritten so that they both use the same code

  const appointmentTypeId = ctx.appointmentType?.id === '35f42b66-7450-4df4-9226-63a49d9cde78'
  ? ctx.store?.appointmentTypeId
  : ctx.appointmentType?.id;
  let limit = 90;
  if (appointmentTypeId == '9b0ff9f0-29bf-4653-9d23-e875346bbb9a') {
    limit = 14;
  }
  const shopNumber = ctx.store?.shopNumber;

  const reduceThis = (slots: FreeSlot[]) =>
  slots
    .sort((a, b) => new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime())
    .reduce<SlotsByDate>((acc, slot) => {
      const date = formatDate(new Date(slot.startDateTime), 'yyyy-MM-dd');
      acc[date] = acc[date] || [];
      acc[date].push(slot);
      return acc;
    }, {});

  useEffect(() => {
    if (isSubmitted){
      if (appointmentTypeId && shopNumber) {
      setIsLoading(true);
      const { cancel } = getStoreSlots({ appointmentTypeId, limit, shopNumber })
        .then((res) => {
          setStoreSlots(res.success ? reduceThis(res.payload.slots) : null);
        })
        .catch(() => {
          setStoreSlots(null);
        })
        .finally(() => setIsLoading(false));
      return cancel;
    } else {
      setStoreSlots(null);
    }
    console.log(slotsByDate);
    }
  }, [isSubmitted])


  useEffect(() => {
    if (slotsByDate) {
      if (!checkIfSlotIsStillAvailable()) {
        setSlotAvailability(false);
        return;
      } else {
        const { utm_campaign, utm_content, utm_medium, utm_source, utm_term } = qs.parse(window.location?.search || '', {
      ignoreQueryPrefix: true,
    });

    const { utmCampaign, utmContent, utmMedium, utmSource, utmTerm } = JSON.parse(
      document.cookie.match('(^|;)\\s*utmCookie\\s*=\\s*([^;]+)')?.pop() || '{}',
    );

    const sanitizeUtm = (p: string | qs.ParsedQs | string[] | qs.ParsedQs[] | undefined) =>
      typeof p === 'string' ? p : undefined;

    //we now eventually take the appointment type id from the store (before, we always took it from the selection on first screen)
    //this is only the case if the user has chosen appointment type "Adviesgesprek (30 minuten)", which has appointment type id "35f42b66-7450-4df4-9226-63a49d9cde78"
    const appointmentTypeIdToBeSent =
      ctx.appointmentType?.id === '35f42b66-7450-4df4-9226-63a49d9cde78'
        ? ctx.store?.appointmentTypeId
        : ctx.appointmentType?.id;

    regAppointment({
      appointmentOnBehalfOf: ctx.personalInformation?.appointmentOnBehalfOf,
      appointmentTypeId: appointmentTypeIdToBeSent,
      dateOfBirth: ctx.personalInformation?.dateOfBirth,
      emailAddress: ctx.personalInformation?.emailAddress,
      endDateTime: ctx.storeSlot?.endDateTime,
      firstName: ctx.personalInformation?.firstName,
      gender: ctx.personalInformation?.gender,
      houseNumber: ctx.personalInformation?.houseNumber,
      lastName: ctx.personalInformation?.lastName,
      note: `Appointment Type Chosen: ${ctx.appointmentTypeName}
      Receive newsletters: ${ctx.personalInformation?.agreementMarketing}

      Customer note:
      ${ctx.personalInformation?.note}
            `,
      phoneNumber: ctx.personalInformation?.phoneNumber,
      postcode: ctx.personalInformation?.postcode,
      roomId: ctx.storeSlot?.roomId,
      shopNumber: ctx.store?.shopNumber,
      startDateTime: ctx.storeSlot?.startDateTime,
      utmCampaign: sanitizeUtm(utm_campaign || utmCampaign),
      utmContent: sanitizeUtm(utm_content || utmContent),
      utmMedium: sanitizeUtm(utm_medium || utmMedium),
      utmSource: sanitizeUtm(utm_source || utmSource),
      utmTerm: sanitizeUtm(utm_term || utmTerm),
    });
        return;
      }
    }
  }, [slotsByDate])

  const checkIfSlotIsStillAvailable = () => {
    let returnValue = false;
    const storeSlot = ctx.storeSlot;
    const dateString = storeSlot?.startDateTime;
    if (dateString) {
      const date = formatDate(new Date(dateString), 'yyyy-MM-dd');
      if (slotsByDate) {
        const slots = slotsByDate[date];
        slots.forEach((slot) => {
          const d1 = new Date(slot.startDateTime);
          const d2 = new Date(dateString);
          if (d1.getTime() == d2.getTime()) {
            returnValue = true;
            return;
          }
        });
      }
    }
    return returnValue;
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setIsSubmitted(true);
  };

  useEffect(() => {
    if (postAppointmentResponse) {
      window.location.href = postAppointmentResponse.retUrl;
    }
  }, [postAppointmentResponse]);

  const stepMax = (window as any).maxStep ?? 5;

  return (
    <div className={classes.container}>
      <h2>{intl.formatMessage({ id: 'summary.title' })}</h2>
      <h3 className={classes.floatingHeader}>{intl.formatMessage({ id: 'summary.reminder' })}</h3>
      {ctx.personalInformation && ctx.appointmentType && ctx.store && ctx.storeSlot && (
        <>
          <div className={classes.detail}>
            <div className={classes.text}>
              <p>{intl.formatMessage({ id: 'summary.appointmentType' })}</p>
              {promotions ? <span>{intl.formatMessage({ id: 'promotions.title' })}</span> : <span>{appointment}</span>}
            </div>
            <div className={classes.edit}>
              <button type='button' onClick={() => handleEdit(1)}>
                {intl.formatMessage({ id: 'summary.edit' })}
              </button>
            </div>
          </div>

          <div className={classes.detail}>
            <div className={classes.text}>
              <p>{intl.formatMessage({ id: 'summary.store' })}</p>
              <span>
                {name}, {city}
              </span>
            </div>
            <div className={classes.edit}>
              <button type='button' onClick={() => handleEdit(stepMax == 5 ? 3 : 2)}>
                {intl.formatMessage({ id: 'summary.edit' })}
              </button>
            </div>
          </div>

          <div className={classes.detail}>
            <div className={classes.text}>
              <p>{intl.formatMessage({ id: 'summary.date' })}</p>
              <span>{formatSelectedSlot(intl.locale, new Date(startDateTime || ''))}</span>
            </div>
            <div className={classes.edit}>
              <button type='button' onClick={() => handleEdit(stepMax == 5 ? 3 : 2)}>
                {intl.formatMessage({ id: 'summary.edit' })}
              </button>
            </div>
          </div>

          <div className={classes.detail}>
            <div className={classes.text}>
              <p>{intl.formatMessage({ id: 'summary.personalnfo' })}</p>
              <span>
                {firstName} {lastName}
              </span>
            </div>
            <div className={classes.edit}>
              <button type='button' onClick={() => handleEdit(stepMax == 5 ? 4 : 3)}>
                {intl.formatMessage({ id: 'summary.edit' })}
              </button>
            </div>
          </div>
        </>
      )}

      {!slotAvailability && (
        <div className={classes.timeslotVerification}>
          <span>{intl.formatMessage({ id: 'summary.timeslotVerificationDescription' })}</span>
        </div>
      )}

      {!slotAvailability && (
        <button type='button' className={classes.button} onClick={() => handleEdit(stepMax == 5 ? 3 : 2)}>
          {intl.formatMessage({ id: 'summary.returnToTimeslots' })}
        </button>
      )}

      <button
        type='submit'
        className={classes.button}
        disabled={isSubmitted}
        onClick={(e) => handleClick(e)}
      >
        {isSubmitted && <Icon path={mdiLoading} size='16px' className={classes.loadingButtonSpinner} />}{' '}
        {intl.formatMessage({ id: 'summary.bookAppointment' })}
      </button>
    </div>
  );
};
Summary.displayName = 'Summary';

export default Summary;
